var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('subHead',{attrs:{"active":1,"subpageActive":_vm.subpageActive}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }